import React from "react"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { VisibilityProvider } from "src/components/visibility-provider"
import { usePermission } from "src/hooks"
import { useUpdateHeaderTitle } from "src/hooks/use-update-header-title"
import { DrawerCreate } from "src/pages-lib/live-love-work/drawer-create"
import { DrawerEdit } from "src/pages-lib/live-love-work/drawer-edit"
import {
  useGetLiveWorkItems,
  useManageItems,
} from "src/pages-lib/live-love-work/model"
import {getColumns} from "../pages-lib/live-love-work/table-columns";
import styled from "styled-components";
import {Table as AntTable} from "antd";

export default function LiveLoveWork() {
  const { hasPermission } = usePermission()
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  const { items, refetch: getItems, pagination, isLoading, handleTableChange } = useGetLiveWorkItems()

  const headerTitle = useUpdateHeaderTitle({
    items,
    defaultTitle: "0 Объектов",
    arrType: ["Объект", "Объекта", "Объектов"],
  })

  const { editData, onDelete, onEditItem, resetEditData } = useManageItems(
    items,
    getItems,
    onSuccessEdit
  )

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState)
  }

  function closeDrawerCreate() {
    setCreateDrawerState(false)
    getItems()
  }

  function closeDrawerEdit() {
    setEditDrawerState(false)
    resetEditData()
    getItems()
  }

  const columns = getColumns(hasPermission("live-love-work.edit") ? onEditItem : null, hasPermission("live-love-work.delete") ? onDelete : null)

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={hasPermission("live-love-work.create") ? () => setCreateDrawerState(true) : undefined}
            titles={{ onCreate: "Добавить объект" }}
          />
        }
      />
      <StyledTable
          dataSource={items}
          columns={columns}
          pagination={pagination}
          onChange={handleTableChange}
          loading={isLoading}
      />
      {hasPermission("live-love-work.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <DrawerCreate onClose={closeDrawerCreate} />
        </VisibilityProvider>
      )}

      {hasPermission("live-love-work.edit") && (
        <VisibilityProvider visible={editDrawerState && editData}>
          <DrawerEdit onClose={closeDrawerEdit} initialData={editData} />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
